import { Grid } from "@material-ui/core";
import React from "react";
import "./onboarding.scss";
import ButtonLinkAccount from "components/buttons/primary-buttons/ButtonLinkAccount";
import ButtonUnlinkAccount from "components/buttons/primary-buttons/ButtonUnlinkAccount";
import AccountStatus from "./components/account-status/account-status";
import ChangeAccount from "./components/change-account/change-account";
import Header from "./components/header/header";
import LoginPortimaConnect from "./components/login-portima-connect/login-portima-connect";
import UserInfoPanel from "./components/user-info/user-info-panel";
import WhatIsItsme from "./components/what-is-itsme/what-is-itsme";
import { Status } from "models/account-status.model";
import useOnboarding, { OnboardingErrorType } from "hooks/useOnboarding";
import ErrorDialog from "components/dialogs/ErrorDialog";
import useDialog from "hooks/useDialog";

import { useTranslation } from "react-i18next";
import { linkAccountUrl } from "utils/urlProvider";
import GridSpacing from "components/grid/GridSpacing";
import Spinner from "components/Spinner";

type Props = {
    location: {
        state?: {
            phoneNumber?: string;
            status?: Status;
        };
    };
};

const Onboarding = ({ location }: Props): React.ReactElement => {
    const { isDialogOpen, dialogTitle, dialogMessage, openDialog, closeDialog } = useDialog();
    const { t } = useTranslation();

    const onBoardingError = (errorType: OnboardingErrorType): void => {
        if (errorType !== OnboardingErrorType.PORTIMACONNECT_MISSING) {
            openDialog(t("Common.Error.Technical"), t("Common.Error.Unknown"));
        }
    };

    const { state } = location;

    const [userInfo, inProgress, unlinkAcount] = useOnboarding(
        {
            ...state,
            errorOccur: onBoardingError,
        } || { onBoardingError },
    );

    const onReload = (): void => {
        window.location.reload();
    };

    const handleLinkAccount = (): void => {
        window.location.href = linkAccountUrl;
    };

    const linkOrUnlinkAccount = (): React.ReactElement => {
        return userInfo.status === "link" || userInfo.status === "newlink" ? (
            <ButtonUnlinkAccount onDecouple={unlinkAcount} />
        ) : (
            <ButtonLinkAccount onClick={handleLinkAccount} />
        );
    };
    return (
        <div className="Home">
            <Grid container>
                <Spinner isLoading={inProgress} />
                <Header />
                <Grid item xs={3} />

                <Grid item xs={6}>
                    <AccountStatus status={userInfo.status} />
                    {userInfo.status !== "notfound" ? (
                        <Grid container justifyContent="center" style={{ paddingTop: "1em", paddingBottom: "1em" }}>
                            <UserInfoPanel userInfo={userInfo} />
                            {linkOrUnlinkAccount()}
                            <ChangeAccount onReload={onReload} />
                        </Grid>
                    ) : (
                        <LoginPortimaConnect />
                    )}

                    <div
                        style={{
                            borderTop: "1px solid #e8ebeb",
                            width: "100%",
                            paddingBottom: "1.5em",
                        }}
                    />
                    <WhatIsItsme />
                </Grid>
                <Grid item xs={3} />
            </Grid>
            <GridSpacing size={80} />
            <ErrorDialog title={dialogTitle} text={dialogMessage} isOpen={isDialogOpen} onClose={closeDialog} />
        </div>
    );
};

export default Onboarding;
